import 'bootstrap/js/dist/modal';

export default function ranking_info_window() {
    $('.ranking-link').mouseenter(function (e) {
        const offset = $(this).offset();
        $('body').append(`<div id="ranking-info" class="ranking-info" style="top: ${offset.top}px; left: ${offset.left + 30}px;">${$(this).next('div').html()}</div>`);
    }).mouseleave( function () {
        $('#ranking-info').remove();
    } );
}